import React from "react";

const LightingBackground = () => (
  <div style={{
    position: "fixed",
    inset: 0,
    zIndex: 0,
    pointerEvents: "none",
    width: "100vw",
    height: "100vh",
    overflow: "hidden"
  }}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1920 1080"
      fill="none"
    
      style={{ position: "absolute", top: 0, left: 0 }}
    >
      <defs>
        <radialGradient id="light1" cx="50%" cy="50%" r="60%" fx="60%" fy="40%" gradientTransform="rotate(20)">
          <stop offset="0%" stopColor="#7c3aed" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#0f172a" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="light2" cx="50%" cy="50%" r="60%" fx="30%" fy="70%" gradientTransform="rotate(-15)">
          <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.18" />
          <stop offset="100%" stopColor="#0f172a" stopOpacity="0" />
        </radialGradient>
      </defs>
      <ellipse cx="1400" cy="300" rx="600" ry="350" fill="url(#light1)" />
      <ellipse cx="600" cy="800" rx="500" ry="300" fill="url(#light2)" />
    </svg>
  </div>
);

export default LightingBackground;
